var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 5.33317C1.3335 3.86041 2.5274 2.6665 4.00016 2.6665H12.0002C13.4729 2.6665 14.6668 3.86041 14.6668 5.33317V10.6665C14.6668 12.1393 13.4729 13.3332 12.0002 13.3332H4.00016C2.5274 13.3332 1.3335 12.1393 1.3335 10.6665V5.33317ZM4.00016 3.99984C3.26378 3.99984 2.66683 4.59679 2.66683 5.33317V10.6665C2.66683 11.4029 3.26378 11.9998 4.00016 11.9998H12.0002C12.7365 11.9998 13.3335 11.4029 13.3335 10.6665V5.33317C13.3335 4.59679 12.7365 3.99984 12.0002 3.99984H4.00016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14611 5.58372C4.37612 5.29622 4.79565 5.2496 5.08315 5.47961L8.00002 7.8131L10.9169 5.47961C11.2044 5.2496 11.6239 5.29622 11.8539 5.58372C12.0839 5.87123 12.0373 6.29076 11.7498 6.52077L8.00002 9.5206L4.25023 6.52077C3.96272 6.29076 3.91611 5.87123 4.14611 5.58372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestMail);
export default __webpack_public_path__ + "static/media/request-mail.2df0c7b8e2b36738f9386bcb7c675ffc.svg";
export { ForwardRef as ReactComponent };